module.exports = __webpack_public_path__ + "img/绿色.dda16c1b.jpg";